/**
 * https://www.pdftron.com/api/web/Core.AnnotationManager.html#isAnnotationSelected__anchor
 */
export default annotation => window.documentViewer.getAnnotationManager().isAnnotationSelected(annotation);
